import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {MATERIAL_THUMBNAIL_TYPE} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "glen raven" as const

const options: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        tiff: "tif",
    },
}

export const schemas: FilenameSchemaEntry[] = [
    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "$MATERIAL_RANGE_NAME$-$MATERIAL_NAME$_$MATERIAL_ARTICLE_ID$_tileable_$WIDTH_IN$x$HEIGHT_IN$.$IMAGE_FORMAT$",
        options: {
            ...options,
            fractionDigits: 1,
            decimalSeparator: ".",
        },
    },

    // thumbnails
    ...MATERIAL_THUMBNAIL_TYPE.map((type) => ({
        type,
        schema: "$MATERIAL_RANGE_NAME$-$MATERIAL_NAME$_$MATERIAL_ARTICLE_ID$.$IMAGE_FORMAT$",
        options,
    })),
]
